'use strict';

function getQueryUrl(url, params) {
  params = Object.keys(params)
    /* jshint eqnull: true */
    .filter(key => params[key] != null)
    .map(key => `${key}=${window.encodeURIComponent(params[key])}`)
    .join('&');

  if (params) {
    url += '?' + params;
  }

  return url;
}

module.exports = getQueryUrl;


/** WEBPACK FOOTER **
 ** ./utils/getQueryUrl.js
 **/